module.exports = __webpack_public_path__ + "img/employment-active.c34c74a6.svg";